// Shared non-component exports; keep component modules valid Fast Refresh boundaries.
import { slugify } from "./format";

// Stable per-agent identifiers. Slug is for the URL; lookup-key is the
// stable identifier the API uses to resolve the agent on the server.

export function agentSlug(row: {
  full_name: string | null;
  email: string | null;
  agent_id: string | null;
}): string {
  const base =
    row.full_name ||
    (row.email ? row.email.split("@")[0] : null) ||
    row.agent_id ||
    "agent";
  return slugify(base) || "agent";
}

export function agentLookupKey(row: {
  agent_id: string | null;
  email: string | null;
  full_name: string | null;
}): string | null {
  return row.agent_id || row.email || row.full_name || null;
}

export const BRAND_PILL: Record<string, string> = {
  petnsur: "bg-primary/15 text-primary",
  autolife: "bg-destructive/15 text-destructive",
  broadlands: "bg-accent/20 text-accent-foreground",
  beneficial: "bg-secondary/15 text-secondary",
  unknown: "bg-muted text-muted-foreground",
};

export function initialsOf(
  name: string | null,
  email: string | null,
): string {
  const src = (name || email || "?").trim();
  if (!src) return "?";
  const parts = src.split(/\s+/).filter(Boolean);
  const firstPart = parts[0];
  const lastPart = parts[parts.length - 1];
  if (parts.length >= 2 && firstPart !== undefined && lastPart !== undefined) {
    return (firstPart.charAt(0) + lastPart.charAt(0)).toUpperCase();
  }
  const letters = src.replace(/[^a-zA-Z]/g, "");
  return (letters.slice(0, 2) || src.slice(0, 2)).toUpperCase();
}
